import { computed } from 'vue'
import { useUser } from '@shopware/composables'

/**
 * Entry point into the checkout funnel.
 *
 * Visitors without a session are routed through the login screen first, which offers
 * login, social login and the guest path. The returnUrl brings them back to the
 * checkout once they picked one. Everyone with a customer or guest session skips
 * that step and goes straight to the checkout.
 */
export function useCheckoutEntry() {
    const { isLoggedIn, isGuestSession } = useUser()

    const hasSession = computed(() => isLoggedIn.value || isGuestSession.value)

    const checkoutEntryPath = computed(() =>
        hasSession.value ? '/checkout' : '/customer/login?returnUrl=checkout'
    )

    return {
        checkoutEntryPath
    }
}
